<template>
  <div class="role_wrapper">
    <div style="margin-bottom:20px;">
      <el-form :inline="true" ref="formSearch" :model="formSearch" class="demo-form-inline">
        <el-form-item label="账户级别">
          <el-select v-model="formSearch.userLevel" placeholder="账户级别" clearable>
            <el-option
              v-for="item in userLevelList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="账户状态">
          <el-select v-model="formSearch.activeStatus" placeholder="账户状态" clearable>
            <el-option
              v-for="item in activeStatusList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备类型">
          <el-select v-model="formSearch.driverType" placeholder="设备类型" clearable>
            <el-option
              v-for="item in driverTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="setting">区间金额赠金规则设置</el-button>
          <el-button type="success" @click="handleAddAmount">新增固定金额赠金规则</el-button>
          <el-button @click="handleAlert">存款弹框提示语设置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table
      border
      v-loading="loading"
      :data="newListData"
      style="width: 100%"
    >
      <el-table-column label="账户级别" width="90" fixed="left">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ filterUserLevel(scope.row.userLevel) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="账户状态" width="90" fixed="left">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ filterActiveStatus(scope.row.activeStatus) }}</span>
        </template>
      </el-table-column>

      <el-table-column label="设备类型" width="90" fixed="left">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ filterDriverType(scope.row.driverType) }}</span>
        </template>
      </el-table-column>

      <template v-for="i in 9">
        <el-table-column :key="'amount_' + i" :label="'固定金额' + i" width="90">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.amounts[i-1] ? scope.row.amounts[i-1].key : '' }}</span>
          </template>
        </el-table-column>
        <el-table-column :key="'bonus_' + i" :label="'赠金' + i" width="90">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.amounts[i-1] ? (scope.row.amounts[i-1].bonus !== undefined && scope.row.amounts[i-1].bonus !== null ? scope.row.amounts[i-1].bonus : convertValue(scope.row.amounts[i-1].key, scope.row)) : '' }}</span>
          </template>
        </el-table-column>
      </template>
      <el-table-column label="提示语" width="120" fixed="right">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.markedWords | formatMarkedWords}}</span>
        </template>
      </el-table-column>
      <el-table-column label="更新人" width="90" fixed="right">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.updateUser}}</span>
        </template>
      </el-table-column>
      <el-table-column label="最后更新时间" width="140" fixed="right">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{formatDate(scope.row.updateDate)}}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('common.handle')" width="180" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="small"
            @click="handleAmount(scope.row)"
          >{{$t("common.edit")}}
          </el-button>
          <el-button
            size="small"
            type="danger"
            @click="handleDeleteRow(scope.row)"
          >{{$t("common.delete") || '删除'}}
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 编辑用户弹窗 -->
    <el-dialog :visible.sync="showAmountBox" :title="isEditMode ? '编辑固定金额' : '新增固定金额'">
      <el-form :model="amountForm">
        <el-form-item label="账户级别" prop="userLevel" :label-width="formLabelWidth">
          <el-select v-model="amountForm.userLevel" :disabled="isEditMode" placeholder="请选择">
            <el-option v-for="item in userLevelList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="账户状态" prop="activeStatus" :label-width="formLabelWidth">
          <el-select v-model="amountForm.activeStatus" :disabled="isEditMode" placeholder="请选择">
            <el-option v-for="item in activeStatusList" :key="item.value" :label="item.label" :value="Number(item.value)"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备类型" prop="driverType" :label-width="formLabelWidth">
          <el-select v-model="amountForm.driverType" :disabled="isEditMode" placeholder="请选择">
            <el-option v-for="item in driverTypeList" :key="item.value" :label="item.label" :value="Number(item.value)"></el-option>
          </el-select>
        </el-form-item>

        <div class="border2">
          <div style="display:flex;margin-bottom: 15px;align-items:center;font-weight:bold;margin-left: 70px;">
            固定金额设置 <div style="color:#0096dc;cursor:pointer;margin-left: 30px" @click="addAmountItem()">添加固定金额</div>
          </div>
          <ul v-for="(item, index) in amountForm.amounts" :key="index">
            <li>固定金额{{ index + 1 }}</li>
            <li><el-input v-model="item.key" @change="amountChanged(item)" auto-complete="off"></el-input> 美元</li>
            <li><el-radio v-model="editRadio" :label="String(index)">默认</el-radio></li>
            <li style="display: flex; align-items: center;">赠金{{ index + 1 }}：<el-input v-model="item.bonus" auto-complete="off" style="width: 80px; margin-left: 5px;"></el-input></li>
            <li><el-button type="text" style="color: #F56C6C;" icon="el-icon-delete" @click="removeAmountItem(index)">删除</el-button></li>
          </ul>
        </div>
        <el-form-item label="提示语" prop="markedWords" :label-width="formLabelWidth">
          <el-input type="textarea" v-model="amountForm.markedWords" auto-complete="off"></el-input>
          <label>
            超链接插入示例：<br>
            超过$500,&lt;a href=&quot;<label style="color: red">在线客服的链接地址</label>&quot;  class=&quot;ui-link&quot;&gt;
            <label style="color: red">联系客服</label>&lt;/a&gt;领取现金红包
          </label>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showAmountBox = false">{{$t("common.cancle")}}</el-button>
        <el-button type="primary" @click="changeAmount">{{$t("common.ok")}}</el-button>
      </div>
    </el-dialog>

    <!-- 编辑用户弹窗 -->
    <el-dialog :visible.sync="showAlertBox">
      <el-form :model="editAlertForm">
        <el-form-item label="激活用户" prop="actived" :label-width="formLabelWidth">
          <el-input type="textarea" v-model="editAlertForm.actived" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="未激活用户" prop="noActived" :label-width="formLabelWidth">
          <el-input type="textarea" v-model="editAlertForm.noActived" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showAlertBox = false">{{$t("common.cancle")}}</el-button>
        <el-button type="primary" @click="changeAlert">{{$t("common.ok")}}</el-button>
      </div>
    </el-dialog>

    <!-- 赠金设置 -->
    <settingUpdate v-show="addOrUpdateVisible" @refreshDataList="getUserList" ref="settingUpdate"></settingUpdate>
  </div>
</template>

<script>
    import {localRead} from "@/utils/tools";
    import {MessageBox, Message} from "element-ui";
    import DateUtil from '@/utils/IM/tradeDataUtil.js';
    import Qs from 'qs';
    import URL from '@/views/newmis36/util/url';
    import settingUpdate from '@/views/newmis36/tracker/settingUpdate.vue'

    export default {
        components: {
            settingUpdate
        },
        data() {
            return {
                userLevelList: [
                    {
                        value: 'MIN',
                        label: "迷你"
                    },
                    {
                        value: 'STD',
                        label: "标准"
                    },
                    {
                        value: 'PLA',
                        label: "铂金"
                    }
                ],
                activeStatusList: [
                    {
                        value: '0',
                        label: "未激活"
                    },
                    {
                        value: '1',
                        label: "已激活"
                    }
                ],
                driverTypeList: [
                    {
                        value: '0',
                        label: "移动端"
                    },
                    {
                        value: '1',
                        label: "PC端"
                    }
                ],
                listData: [],
                active:{},
                ruleList: {},
                formSearch: {
                    userLevel: "",
                    activeStatus: "",
                    driverType: ""
                },
                loading: true,
                showAmountBox: false,
                showAlertBox:false,
                formLabelWidth: "150px",
                addOrUpdateVisible:false,
                edit: true,
                isEditMode: true,
                editRadio:"1",
                amountForm: {
                    userLevel: "",
                    activeStatus: "",
                    driverType: "",
                    amounts: [
                        {value: 0, key: 0},
                        {value: 0, key: 0},
                        {value: 0, key: 0},
                        {value: 0, key: 0},
                        {value: 0, key: 0},
                        {value: 0, key: 0},
                    ],
                    markedWords:""
                },
                editForm:{
                    userLevel:"",
                    activeStatus:"",
                    driverType:""
                },
                editAlertForm:{
                    actived:"",
                    noActived:"",
                }

            };
        },
        created() {
        },
        computed: {
            newListData: {
                get() {
                    if (!this.formSearch.userLevel && !this.formSearch.driverType && !this.formSearch.activeStatus) {
                        return this.listData;
                    }
                    let newList = this.listData.filter(this.doFilter);
                    return newList;
                }
            }
        },
        mounted() {
            this.getUserList();
            this.depositAlertList();
        },
        methods: {
            getUserList() {
                this.$axios.get(URL.amountSetting.list).then(res => {
                    if (res.code == 0) {
                        this.listData = res.result.list;
                        this.ruleList = res.result.rule;
                        this.loading = false;
                    }
                });
            },
            depositAlertList() {
                this.$axios.get(URL.amountSetting.depositAlertList).then(res => {
                    if (res.code == 0) {
                        this.active = res.result;
                        this.loading = false;
                    }
                });
            },
            doFilter(element, index, array) {
                if (this.formSearch.activeStatus && this.formSearch.activeStatus != element.activeStatus) {
                    return false;
                }
                if (this.formSearch.userLevel && this.formSearch.userLevel != element.userLevel) {
                    return false;
                }
                if (this.formSearch.driverType && this.formSearch.driverType != element.driverType) {
                    return false;
                }
                return true;
            },
            resetSearch() {
                this.formSearch = {};
            },
            filterUserLevel(data) {
                if (data === "MIN") {
                    return "迷你";
                } else if (data === "STD") {
                    return "标准";
                } else if (data === "PLA") {
                    return "铂金";
                }
                return "巴菲特";
            },
            filterActiveStatus(data) {
                if (data == 0) {
                    return "未激活";
                }
                return "已激活";
            },
            filterDriverType(data) {
                if (data == 0) {
                    return "移动端";
                }
                return "PC端";
            },
            formatMarkedWords(data) {
                if (!DateUtil.isEmpty(data)) {
                    if (data.length > 20) {
                        return data.substring(0, 20) + "...";
                    }
                }
                return data;
            },
            convertValue(amount, full) {
                var value = 0;
                if (this.ruleList) {
                    var rules = this.ruleList.amountRule || this.ruleList.aountRule || [];
                    for (var i = 0; i < rules.length; i++) {
                        var tmp = rules[i];
                        if (this.ruleList.userLevel.indexOf(full.userLevel) != -1) {
                            if (tmp.activeStatus == full.activeStatus) {
                                if (amount >= tmp.gt) {
                                    value = tmp.amount;
                                }
                                if (tmp.lt) {
                                    if (amount < tmp.lt) {
                                        break;
                                    } else {
                                        value = 0;
                                    }
                                }
                            }
                        }
                    }
                }
                return value;
            },
            amountChanged(obj) {
                this.$set(obj, 'bonus', this.convertValue(obj.key, this.amountForm));
            },
            formatDate(val) {
                if (val) {
                   return  DateUtil.formatDate(val, "yyyy-MM-dd hh:mm:ss");
                }
            },
            handleAmount(row) {
                this.isEditMode = true;
                this.amountForm = {
                    ...this.amountForm,
                    ...row
                };
                this.showAmountBox = true;
                //循环初始化赠金
                 this.amountForm.amounts.forEach((value,index)=>{
                    if(value.value==1){
                       this.editRadio = String(index);
                    }
                    if (value.bonus === undefined || value.bonus === null) {
                        this.$set(value, 'bonus', this.convertValue(value.key, this.amountForm));
                    }
                });
            },
            getI18nText(key, fallbackText) {
                return (this.$te && this.$te(key)) ? this.$t(key) : fallbackText;
            },
            handleAddAmount() {
                this.isEditMode = false;
                this.editRadio = "1";
                this.amountForm = {
                    userLevel: "",
                    activeStatus: "",
                    driverType: "",
                    amounts: [
                        { key: "", value: 0, bonus: 0 },
                        { key: "", value: 0, bonus: 0 },
                        { key: "", value: 0, bonus: 0 }
                    ],
                    markedWords: "",
                    businessType: "CFINT"
                };
                this.showAmountBox = true;
            },
            addAmountItem() {
                if (this.amountForm.amounts.length >= 9) {
                    this.$message.warning(this.getI18nText("amountSetting.maxLimit", "固定金额最多设置9个"));
                    return;
                }
                this.amountForm.amounts.push({ key: "", value: 0, bonus: 0 });
            },
            removeAmountItem(index) {
                if (this.amountForm.amounts.length <= 3) {
                    this.$message.warning(this.getI18nText("amountSetting.minLimit", "固定金额必须设置至少3个"));
                    return;
                }
                this.amountForm.amounts.splice(index, 1);
                if (String(index) === this.editRadio) {
                    this.editRadio = "0";
                } else if (Number(this.editRadio) > index) {
                    this.editRadio = String(Number(this.editRadio) - 1);
                }
            },
            changeAmount() {
                if (this.amountForm.userLevel === "" || this.amountForm.activeStatus === "" || this.amountForm.driverType === "") {
                    this.$message.error("请选择完整的账户级别、账户状态和设备类型");
                    return;
                }
                // 验证至少3个有效金额
                const validItems = this.amountForm.amounts.filter(item => !DateUtil.isEmpty(item.key) && Number(item.key) > 0);
                if (validItems.length < 3) {
                    this.$message.error(this.getI18nText("amountSetting.minValidLimit", "固定金额必须设置至少3个,且都大于0"));
                    return;
                }
                this.amountForm.amounts.forEach((value,index)=>{
                    value.value = 0;
                    //处理默认选中
                    if(index==this.editRadio){
                        value.value = 1;
                    }
                    if(value.key==null){
                        value.key="";
                    }
                });
                this.$axios.post(URL.amountSetting.edit, Qs.stringify(this.amountForm,{arrayFormat: 'indices', allowDots: true})).then(res => {
                        if(res.code==0){
                            this.$message.success(this.getI18nText("common.changeSu", "修改成功"));
                            this.getUserList();
                        }else{
                            this.$message.error(res.message || this.getI18nText("common.fail", "提交失败"));
                        }
                }).catch(res => {
                    this.$message.error(this.getI18nText("common.fail", "提交失败"));
                });

                this.showAmountBox = false;
            },
            handleDeleteRow(row) {
                if (!row || !row.userLevel || row.activeStatus === undefined || row.driverType === undefined) {
                    this.$message.error("参数不完整，无法删除");
                    return;
                }
                this.$confirm("确认要删除该笔固定金额设置吗？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    const payload = {
                        businessType: row.businessType || "CFINT",
                        userLevel: row.userLevel,
                        activeStatus: row.activeStatus,
                        driverType: row.driverType
                    };
                    this.$axios.post(URL.amountSetting.deleteRow, payload, {
                        headers: { 'Content-Type': 'application/json' }
                    }).then(res => {
                        if (res.code === 0) {
                            this.$message.success("删除成功");
                            this.showAmountBox = false;
                            this.getUserList();
                        } else {
                            this.$message.error(res.message || "删除失败");
                        }
                    }).catch(err => {
                        this.$message.error("删除失败");
                    });
                }).catch(() => {
                });
            },
            handleAlert() {
                this.showAlertBox = true;
                this.editAlertForm = {
                    ...this.editAlertForm,
                    ...this.active
                };
            },
            changeAlert() {
                this.$axios.post(URL.amountSetting.editDepositAlert, this.editAlertForm || {},{ headers: { 'Content-Type': 'application/json' } }).then(res => {
                    if(res.code==0){
                        this.$message.success("提交成功");
                        this.depositAlertList();
                    }else{
                        this.$message.error("提交失败");
                    }
                }).catch(res => {
                    this.$message.error("提交失败");
                });

                this.showAlertBox = false;
            },
            setting(){
                //赠金规则设置
                this.addOrUpdateVisible = true;
                this.$nextTick(() => {
                    this.$refs.settingUpdate.init(this.ruleList);
                })
            }
        }
    };
</script>
<style lang="scss" scoped>
  .role_wrapper {
    margin: 50px;
    border: 1px solid #ebebeb;
    border-radius: 3px;
    transition: 0.2s;
    padding: 20px;
  }

  .role_wrapper:hover {
    box-shadow: 0 0 8px 0 rgba(232, 237, 250, 0.6),
    0 2px 4px 0 rgba(232, 237, 250, 0.5);
  }

  .el-table .warning-row {
    background: oldlace;
  }

  .el-table .success-row {
    background: #f0f9eb;
  }

  .border2 {
    margin-bottom: 15px;
    ul{
      display: flex;
      align-items: center;
      margin-left: 70px;
      li{
        margin-right: 20px;
        margin-bottom: 12px;
        .el-input{
          width: 120px;
        }
      }
    }
  }
</style>
